import Header from "../components/Header"
import Body from "../components/Body"
import Footer from "../components/Footer"

function Home() {
    return (
        <div className="home">
            <Header />
            <Body />
            <Footer />
        </div>
    );
}

export default Home;